'use client';

import { Accordion, Span } from '@chakra-ui/react';

import type { FAQItemViewModel } from '@/modules/static/view-model';

export type FAQProps = {
	faqs: FAQItemViewModel[]
};

export const FAQ = ({ faqs }: FAQProps) => {
	return (
		<Accordion.Root collapsible>
			{faqs.map((item, index) => (
				<Accordion.Item color="text" key={index} value={item.value}>
					<Accordion.ItemTrigger>
						<Span flex="1" p={4} textStyle="bodyBold">
							{item.title}
						</Span>
						<Accordion.ItemIndicator />
					</Accordion.ItemTrigger>
					<Accordion.ItemContent p={4} pt={0}>
						<Accordion.ItemBody whiteSpace="pre-wrap">
							{item.text}
						</Accordion.ItemBody>
					</Accordion.ItemContent>
				</Accordion.Item>
			))}
		</Accordion.Root>
	);
};
